import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import BtChecklistSelect from '../bt-checklist-select/bt-checklist-select';
import { HELA_SVERIGE, placeChecklist, STOCKHOLM } from './placeChecklist';

const OPEN_FROM_THE_START = [HELA_SVERIGE, STOCKHOLM];

type Props = {
  places: string[],
  onChange: (places: string[]) => void,
  label?: ReactNode,
  required?: boolean,
};

const AppPlaceChecklist: FC<Props> = ({ places, onChange, label, required }) => {
  const [t] = useTranslation('supplierDatabase');
  const placeholder = label
    ? undefined
    : t('supplierDetailPanel.profileInfo.places.placeholder', 'Platser');
  return (
    <BtChecklistSelect
      label={label}
      required={required}
      placeholder={placeholder}
      options={placeChecklist}
      value={places}
      onChange={onChange}
      groupsSelectable
      defaultExpanded={OPEN_FROM_THE_START}
    />
  );
};

export default AppPlaceChecklist;
